import { CheckIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import { Input2 } from 'stories/components'

export const EditableDocumentTitle = ({
  value,
  defaultValue,
  onChange,
}: {
  value: string
  defaultValue: string
  onChange: (value: string) => void
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [draft, setDraft] = useState(value || defaultValue)

  useEffect(() => {
    if (!isEditing) setDraft(value || defaultValue)
  }, [value, defaultValue, isEditing])

  const displayValue = (value || defaultValue).trim() || defaultValue

  const onSave = () => {
    const next = draft.trim() || defaultValue
    onChange(next)
    setDraft(next)
    setIsEditing(false)
  }

  const onCancel = () => {
    setDraft(value || defaultValue)
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <div className="max-w-xl mx-auto mt-5 mb-2 flex items-end gap-2">
        <div className="flex-1">
          <Input2 title="Document Title" value={draft} required autoFocus onChange={setDraft} />
        </div>
        <button
          type="button"
          className="mb-2 p-1.5 rounded text-green-700 hover:bg-green-50"
          onClick={onSave}
          title="Save"
        >
          <CheckIcon className="w-5 h-5" />
        </button>
        <button
          type="button"
          className="mb-2 p-1.5 rounded text-gray-500 hover:bg-gray-100"
          onClick={onCancel}
          title="Cancel"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-5 mb-2">
      <p className="text-center text-lg font-bold">{displayValue}</p>
      <button
        type="button"
        className="p-1 rounded text-shade-blue hover:bg-blue-50"
        onClick={() => setIsEditing(true)}
        title="Edit document title"
      >
        <PencilSquareIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
